angular.module('relivConference').service(
    'relivConferenceTicketService',
    [
        'rcmApiLibService',
        'rcmLoading',
        function (
            rcmApiLibService,
            rcmLoading
        ) {
            var self = this;
            var loadingNameSpace = 'relivConferenceTicketService.loading';

            /**
             *
             * @param loading
             */
            var onLoading = function (loading) {
                var loadingInt = Number(!loading);
                rcmLoading.setLoading(
                    loadingNameSpace,
                    loadingInt
                );
            };

            /**
             *
             * @param conferenceId
             * @param success
             * @param error
             * @returns {Promise}
             */
            self.getTickets = function (conferenceId, success, error) {
                return rcmApiLibService.get(
                    {
                        url: '/api/conference-tickets',
                        params: {conferenceId: conferenceId},
                        loading: onLoading,
                        success: function (response, status, headers, config) {
                            success(response, status, headers, config);
                        },
                        error: function (response, status, headers, config) {
                            error(response, status, headers, config);
                        },
                    }
                );
            };

            /**
             *
             * @param uid
             * @param success
             * @param error
             * @returns {Promise}
             */
            self.getTicket = function (uid, success, error) {
                return rcmApiLibService.get(
                    {
                        url: '/api/conference-tickets/' + uid,
                        loading: onLoading,
                        success: function (response, status, headers, config) {
                            success(response, status, headers, config);
                        },
                        error: function (response, status, headers, config) {
                            error(response, status, headers, config);
                        },
                    }
                );
            };

            /**
             *
             * @param ticket
             * @param success
             * @param error
             * @returns {Promise}
             */
            self.updateTicket = function (ticket, success, error) {
                return rcmApiLibService.put(
                    {
                        url: '/api/conference-tickets/' + ticket.uid,
                        data: ticket,
                        loading: onLoading,
                        success: function (response, status, headers, config) {
                            success(response, status, headers, config);
                        },
                        error: function (response, status, headers, config) {
                            error(response, status, headers, config);
                        },
                    }
                );
            };

            /**
             *
             * @param ticket
             * @param success
             * @param error
             * @returns {Promise}
             */
            self.deleteTicket = function (ticket, success, error) {
                return rcmApiLibService.del(
                    {
                        url: '/api/conference-tickets/' + ticket.uid,
                        loading: onLoading,
                        success: function (response, status, headers, config) {
                            success(response, status, headers, config);
                        },
                        error: function (response, status, headers, config) {
                            error(response, status, headers, config);
                        },
                    }
                );
            };

            /**
             *
             * @param success
             * @param error
             * @returns {Promise}
             */
            self.getRibbons = function(success, error) {
                return rcmApiLibService.get(
                    {
                        url: '/api/conference-tickets-ribbons',
                        loading: onLoading,
                        success: function (response, status, headers, config) {
                            success(response, status, headers, config);
                        },
                        error: function (response, status, headers, config) {
                            error(response, status, headers, config);
                        },
                    }
                );
            };

            /**
             * getRibbon
             * @param displayRcn
             * @param success
             * @param error
             * @returns {Promise}
             */
            self.getRibbon = function(displayRcn, success, error) {
                return rcmApiLibService.get(
                    {
                        url: '/api/conference-tickets-ribbons/' + displayRcn,
                        loading: onLoading,
                        success: function (response, status, headers, config) {
                            success(response, status, headers, config);
                        },
                        error: function (response, status, headers, config) {
                            error(response, status, headers, config);
                        },
                    }
                );
            };

            return self;
        },
    ]
);
